import { RatingControllerSendRatingMethod } from '../methods/rating-controller/send-rating.method';

export class RatingController {
  public readonly sendRating = new RatingControllerSendRatingMethod();
}
